import { Directive, HostListener, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { DeviceService } from '@shared/tools/device.service';
import { DEVICE_SIZE, mediaConfig } from '@core/models/deviceSize.model';

@Directive({
  selector: '[smallerThan]',
})
export class SmallerThanDirective implements OnInit {
  private hasView = false;
  deviceSize!: DEVICE_SIZE;

  @Input() set smallerThan(deviceSize: DEVICE_SIZE) {
    this.deviceSize = deviceSize;
  }

  constructor(
    private deviceService: DeviceService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.testElement();
  }

  @HostListener('window:resize') testElement() {
    const sizeScreen = this.deviceService.getSizeScreen().width;
    const biggestSize = mediaConfig!.mediaFormats![this.deviceSize]!.width!;
    const showComponente = sizeScreen < biggestSize;

    if (showComponente && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!showComponente && this.hasView) {
      this.viewContainer.remove();
      this.hasView = false;
    }
  }
}
